<template>
    <v-container>
        <v-row v-if="instances">
            <v-col cols="12">
                <div class="my-2 justify-center text-center">
                    <v-btn
                        color="primary"
                        primary
                        large
                        class="justify-center text-center v-btn-list"
                        @click="changeToRequest(instanceItem.index)"
                        v-for="instanceItem in instances"
                        :key="instanceItem.index"
                        >
                        <v-icon>mdi-login</v-icon>&nbsp; Ir para
                        {{ instanceItem.name }}
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { requestTools } from "../mixins/requestTools";

    export default {
        name: "ChangeInstance",

        props: {
            //username: String,
        },

        mixins: [requestTools],

        data: function () {
            return {
                instance: "",
                instances: []
            };
        },

        computed: {

        },

        created: function () {
            EventBus.$emit("eventPageLoad", {name: "Trocar de instância"});
            this.loadInstancelist();
        },

        methods: {
            loadInstancelist() {
                const instances = window.localStorage.getItem("lastInstanceList");
                if (!instances) {
                    return;
                }
                this.instances = JSON.parse(instances);
            },

            async changeToRequest(instanceIndex) {
                const responseData = await this.requestGet("/changeInstance/" + instanceIndex);

                if (!responseData.newJwt) {
                    return EventBus.$emit("toast", {tx: "Não foi possível fazer a troca, verifique se tem permissão"});
                }

                EventBus.$emit("toast", {tx: "Trocando instância..."});

                window.localStorage.setItem(this.$appTokenKey, responseData.newJwt);

                this.gotoMainSubdep();

                EventBus.$emit(this.$instanceChangeEvt);
            },

            gotoMainSubdep() {
                setTimeout(() => {
                    return this.$router.push({name: "SubdepList", params: {gotoMain: true}});
                }, 1000);
            }
        }
    };
</script>

<style>
    .v-btn-list {
        margin: 1px;
        width: 80%;
    }
</style>
